import { createTheme } from '@mui/material/styles'
import { grey } from "@mui/material/colors";

export const theme = createTheme({
  palette: {
    primary: {
      main: '#4285f4',
    },
    secondary: {
      main: '#f0f2f5',
    },
    white: {
      main: '#fff'
    },
    customColor: {
      light: '#f2f2f2',
      default: "#f0f2f5",
      cardBorderColor: "#f2f2f2 !important",
      cardActive: '#eee',
      editorBG: '#fff',
      textDark: '#505050',
      timeBg: '#7d7d7d'
    },
    chatColor: {
      chatRightBg: '#d9fdd3',
      chatLeftBg: '#fff'
    },
    action: {
      hover: '#ecf7ff',
      // active: '#d3ebff'
    },
    background: {
      default: '#efefef',
      tableHead: '#e0e3e8'
    }
  },

  typography: {
    // fontSize: '1.4rem',
    htmlFontSize: 11,
  },
})